import { ReactNode, createContext, useContext, useState } from 'react';

import {
    useGetStoreOverviewQuery,
    useGetStoreSaleOverviewQuery,
} from '../../../features/slice/report/report-api-slice';
import {
    SalesOverview,
    StatsType,
} from '../../../features/slice/report/report.schema';

interface DashboardContextType {
    statsData: StatsType['data'] | null;
    statsFetching: boolean;
    statsLoading: boolean;
    saleLoading: boolean;
    salesData: SalesOverview['data'] | null;
    overviewPeriod: DashboardOverviewPeriod;
    setOverviewPeriod: (period: DashboardOverviewPeriod) => void;
}

export type DashboardOverviewPeriod = 'today' | 'this_month' | 'all_time';

const DashboardContext = createContext<DashboardContextType | undefined>(
    undefined,
);

export const DashboardProvider = ({ children }: { children: ReactNode }) => {
    const [overviewPeriod, setOverviewPeriod] =
        useState<DashboardOverviewPeriod>('today');
    const {
        data: statsData = null,
        isLoading: statsLoading,
        isFetching: statsFetching,
    } = useGetStoreOverviewQuery({ period: overviewPeriod });
    const { data: salesData = [], isLoading: saleLoading } =
        useGetStoreSaleOverviewQuery('');

    return (
        <DashboardContext.Provider
            value={{
                statsData,
                statsFetching,
                statsLoading,
                salesData,
                saleLoading,
                overviewPeriod,
                setOverviewPeriod,
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
};

export const useDashboard = () => {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error('useDashboard must be used within a DashboardProvider');
    }
    return context;
};
